import Modal from 'react-bootstrap/Modal'
import {Button} from 'react-bootstrap'
import { deleteBrick } from '../../http/brickAPI';

function DeleteModal({show,onHide,id,name}) {
    const handleSubmit = async() =>{
        await deleteBrick(id)
        alert(`Карточка была успешно удалена`)
        onHide()
    }
  return (
  <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{fontFamily:'BD',color:'#404040'}}>
            {name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Button className='delete_btn' onClick={handleSubmit}>Да</Button>
            <Button className='blue-btn' style={{margin:'1% 0px 0px 0px',height:'50px'}} onClick={onHide}>Закрыть</Button>
        </Modal.Body>
      </Modal>
  );
}

export default DeleteModal;